import { expect as pwExpect, ExpectMatcherState, Locator, MatcherReturnType } from '@playwright/test';

export const expect = pwExpect.extend({
	async isChecked(this: ExpectMatcherState, receiver: Locator): Promise<MatcherReturnType> {
		console.log(await receiver.getAttribute('checked'));
		expect(await receiver.getAttribute('checked')).toBe('');
		return { message: () => 'Pass', pass: true };
	},
	async isNotChecked(this: ExpectMatcherState, receiver: Locator): Promise<MatcherReturnType> {
		expect(await receiver.getAttribute('checked')).toBeNull();
		return { message: () => 'Pass', pass: true };
	},
	async toHaveValue(this: ExpectMatcherState, receiver: Locator, expected: string): Promise<MatcherReturnType> {
		const actual = await receiver.evaluate((el: HTMLInputElement) => el.value as string);
		const pass = actual === expected;
		return {
			pass,
			message: () => (pass ? `expected value not to be “${expected}”` : `expected value to be “${expected}”, but got ${actual === null ? 'no value' : `“${actual}”`}`),
		};
	},
});
